import { render, staticRenderFns } from "./SpkbBpb.vue?vue&type=template&id=1268b5b6&"
import script from "./SpkbBpb.vue?vue&type=script&lang=js&"
export * from "./SpkbBpb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports